import api from '../config/axiosConfig';

export const EmpresaService = {
    fetchEmpresa: async (token) => {
        try {
            const response = await api.get('/ajustes/empresa', {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.empresa || {};
        } catch (error) {
            console.error('Error en EmpresaService.fetchEmpresa:', error);
            throw error;
        }
    },
    getLogos: async (token) => {
        try {
            const response = await api.get('/auth/logos', {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.empresa || {};
        } catch (error) {
            console.error('Error en EmpresaService.getLogos:', error);
            throw error;
        }
    },
    actualizarEmpresa: async ({ token, empresaData }) => {
        try {
            await api.put('/ajustes/empresa', empresaData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                },
            });
        } catch (error) {
            console.error('Error en EmpresaService.actualizarEmpresa:', error);
            throw error;
        }
    },
};
